// extracted by mini-css-extract-plugin
export default {"flex-column":"imageAction_flex-column__Mn5Uf","image-action":"imageAction_image-action__YpzvI","flex-row":"imageAction_flex-row__nQu22","page-size":"imageAction_page-size__wML0s"};